import { Wallet } from "@/api/user";
import { create } from "zustand";

interface State {
    wallet: Wallet;
    score: Wallet["score"];
}

interface Action {
    setWallet: (state?: Wallet) => void;
    setScore: (state: Wallet["score"]) => void;
    reset: () => void;
}
const initialState: State = {
    wallet: {
        avatar_url: "",
        currency: "",
        current_free_score_rollover: 0,
        current_lose_score_rollover: 0,
        current_point_rollover: 0,
        current_score_rollover: 0,
        deposit: 0,
        first_pay_time: 0,
        free_score: 0,
        lock_point: 0,
        lock_score: 0,
        lose_score: 0,
        nick_name: "",
        point: 0,
        score: 0,
        target_free_score_rollover: 0,
        target_lose_score_rollover: 0,
        target_point_rollover: 0,
        target_score_rollover: 0,
        total_free_score_rollover: 0,
        total_lose_score_rollover: 0,
        total_point_rollover: 0,
        total_receive_red_packet: 0,
        total_red_packet: 0,
        total_score_rollover: 0,
        user_name: "",
        no_bonus_config: 0,
        notice: {
            lose_score: 0,
        },
        free_transfer_max: 0,
        lose_transfer_max: 0,
        withdraw: {
            enable: false,
            balance: 0,
            able_amount: 0,
            clear_balance: 0,
            current_rollover: 0,
            target_rollover: 0,
            tips_pop: false,
            clear_item_ids: [],
        },
    },
    score: undefined,
};
export const useWalletStore = create<State & Action>()((set) => {
    return {
        ...initialState,
        setWallet: (wallet) => {
            set((state) => ({ ...state, wallet }));
        },
        setScore: (score) => {
            set((state) => ({ ...state, score }));
        },
        reset: () => set(initialState),
    };
});
